<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.feedbackQuestionType"
        placeholder="问题类型"
      >
        <el-option
          v-for="(item, i) in feedbackQuestionTypeAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.feedbackChannel"
        placeholder="反馈渠道"
      >
        <el-option
          v-for="(item, i) in feedbackChannelAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.handleStatus"
        placeholder="处理状态"
      >
        <el-option
          v-for="(item, i) in handleStatusAttr"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <butn btntype="primary" title="查询" @click.native="searchFS"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getSysParamByTypes } from "@/api/sysParam";
import Bus from "./Bus";

export default {
  name: "search",
  components: { butn },
  data() {
    return {
      filters: {},
      feedbackQuestionTypeAttr: [],
      feedbackChannelAttr: [],
      handleStatusAttr: [],
    };
  },
  created() {
    this.getSysParamByTypes(["FEEDBACK_QUESTION_TYPE", "CLIENT_TYPE_APP", "HANDLE_STATUS"]);

    Bus.$on("initData", () => {
      // this.searchFS();
      this.$emit("refreshNowPage");
    });
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({types: types}).then((res) => {
        if (!res || res.code != 0) return;
        res.data["FEEDBACK_QUESTION_TYPE"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["CLIENT_TYPE_APP"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        res.data["HANDLE_STATUS"].splice(0, 0, { paramKey: "", paramValue: "全部" });
        this.feedbackQuestionTypeAttr = res.data["FEEDBACK_QUESTION_TYPE"];
        this.feedbackChannelAttr = res.data["CLIENT_TYPE_APP"];
        this.handleStatusAttr = res.data["HANDLE_STATUS"];
      });
    },
    resetData() {
      //重置
      this.filters = {};
      this.searchFS();
    },
    searchFS() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
